import { useState } from 'react'
import { Icon } from '@iconify/react'
import InvoiceList from './components/InvoiceList'
import DiscrepancyTrail from './components/DiscrepancyTrail'
import InvoiceDetailsPage from './components/InvoiceDetailsModal'
import './WeightDiscrepancy.scss'

type ActiveTab = 'invoices' | 'trail'

function WeightDiscrepancy() {
  const [activeTab, setActiveTab] = useState<ActiveTab>('invoices')
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(
    null,
  )
  const [listRefreshKey, setListRefreshKey] = useState(0)

  const handleSelectInvoice = (id: string) => setSelectedInvoiceId(id)
  const handleBack = () => setSelectedInvoiceId(null)
  const handlePaymentSuccess = () => {
    setSelectedInvoiceId(null)
    setListRefreshKey((k) => k + 1)
  }

  if (selectedInvoiceId) {
    return (
      <InvoiceDetailsPage
        invoiceId={selectedInvoiceId}
        onBack={handleBack}
        onPaymentSuccess={handlePaymentSuccess}
      />
    )
  }

  const tabs: { key: ActiveTab; label: string; icon: string }[] = [
    { key: 'invoices', label: 'Invoices', icon: 'mdi:file-document-outline' },
    // { key: 'trail',   label: 'History / Trail',  icon: 'mdi:history' },
  ]

  return (
    <div className='home'>
      {/* Header */}
      <div className='wd-page-header'>
        <div className='wd-header-icon'>
          <Icon icon='mdi:scale-balance' width='26' color='#0056b3' />
        </div>
        <div>
          <h1>Weight Discrepancy</h1>
          <p className='wd-header-sub'>
            Manage and track weight adjustment invoices
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className='wd-tabs'>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`wd-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            <Icon icon={tab.icon} width='16' />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      {activeTab === 'invoices' ? (
        <InvoiceList
          key={listRefreshKey}
          onSelectInvoice={handleSelectInvoice}
        />
      ) : (
        <DiscrepancyTrail />
      )}
    </div>
  )
}

export default WeightDiscrepancy
